import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';

function RuleItem({
  number,
  title,
  description,
}: {
  number: string;
  title: string;
  description: string;
}) {
  return (
    <View style={styles.ruleItem}>
      <View style={styles.numberContainer}>
        <Text.Heading type="hero" style={styles.ruleNumber}>
          {number}
        </Text.Heading>
      </View>
      <View style={styles.ruleTextContainer}>
        <Text.Ui size="md" weight="semibold">
          {title}
        </Text.Ui>
        <Text.Ui size="sm" style={styles.ruleDescription}>
          {description}
        </Text.Ui>
      </View>
    </View>
  );
}

export function EligibilityRules() {
  return (
    <View style={styles.container}>
      <Text.Ui size="lg" weight="semibold">
        Eligibility Rules
      </Text.Ui>
      <Text.Ui size="sm" style={styles.description}>
        To qualify for the Birthday Sub Reward, you must meet the following requirements:
      </Text.Ui>

      <View style={styles.rulesList}>
        <RuleItem
          number="1"
          title="Recent Purchase Required"
          description="You must have placed an order within the last 6 months (excluding orders placed within 7 days of your birthday)."
        />
        <RuleItem
          number="2"
          title="Minimum Purchase Amount"
          description="Your most recent order must total more than $1."
        />
        <RuleItem
          number="3"
          title="Purchase Identification"
          description="Your recent order must be linked to your account online or to your phone number in-restaurant."
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
  },
  description: {
    marginTop: 8,
  },
  rulesList: {
    paddingTop: 16,
    gap: 16,
  },
  ruleItem: {
    flexDirection: 'row',
    backgroundColor: tokens.colors.$houseLight,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  numberContainer: {
    width: 48,
    height: 52,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity04,
  },
  ruleNumber: {
    color: tokens.colors.$houseRed,
  },
  ruleTextContainer: {
    flex: 1,
    paddingLeft: 12,
  },
  ruleDescription: {
    marginTop: 4,
  },
});
